// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_user.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { Empty } from "../../../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { AppRef } from "./app";
import { App } from "./app";
import { Facets } from "../../search/v1/facet";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Struct } from "../../../../google/protobuf/struct";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.api.app.v1.SearchOrphanedAccountsRequest
 */
export interface SearchOrphanedAccountsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 4;
     */
    expandMask?: AppUserExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchOrphanedAccountsResponse
 */
export interface SearchOrphanedAccountsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserView list = 1;
     */
    list: AppUserView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.UserAndCount
 */
export interface UserAndCount {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUser app_user = 1;
     */
    appUser?: AppUser;
    /**
     * @generated from protobuf field: int64 count = 2;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.HighRiskUsersAndGrantsRequest
 */
export interface HighRiskUsersAndGrantsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 3;
     */
    expandMask?: AppUserExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.HighRiskUsersAndGrantsResponse
 */
export interface HighRiskUsersAndGrantsResponse {
    /**
     * @generated from protobuf field: repeated int64 counts = 1;
     */
    counts: number[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserView list = 2;
     */
    list: AppUserView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 4;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CountHighRiskUsersAndGrantsRequest
 */
export interface CountHighRiskUsersAndGrantsRequest {
}
/**
 * @generated from protobuf message c1.api.app.v1.CountHighRiskUsersAndGrantsResponse
 */
export interface CountHighRiskUsersAndGrantsResponse {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserResponsiblePartyExpandMask
 */
export interface AppUserResponsiblePartyExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserResponsiblePartyServiceGetRequest
 */
export interface AppUserResponsiblePartyServiceGetRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 2;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserResponsiblePartyExpandMask expand_mask = 3;
     */
    expandMask?: AppUserResponsiblePartyExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserResponsiblePartyServiceSetRequest
 */
export interface AppUserResponsiblePartyServiceSetRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 2;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string user_id = 3;
     */
    userId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserResponsiblePartyExpandMask expand_mask = 4;
     */
    expandMask?: AppUserResponsiblePartyExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserResponsiblePartyServiceResetRequest
 */
export interface AppUserResponsiblePartyServiceResetRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 2;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserResponsiblePartyExpandMask expand_mask = 3;
     */
    expandMask?: AppUserResponsiblePartyExpandMask;
}
/**
 * The AppUserExpandMask message contains a list of paths to expand in the response.
 *
 * @generated from protobuf message c1.api.app.v1.AppUserExpandMask
 */
export interface AppUserExpandMask {
    /**
     * The paths to expand in the response. May be any combination of "*", "identity_user_id", "app_id", and "last_usage".
     *
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * The AppUserView contains an app user as well as paths for apps, identity users, and last usage in expanded arrays.
 *
 * @generated from protobuf message c1.api.app.v1.AppUserView
 */
export interface AppUserView {
    /**
     * The AppUser included in this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUser app_user = 1;
     */
    appUser?: AppUser;
    /**
     * JSONPATH expression indicating where the identity user is expanded in expanded arrays indicated in the request.
     *
     * @generated from protobuf field: string identity_user_path = 2;
     */
    identityUserPath: string;
    /**
     * JSONPATH expression indicating where the app is expanded in expanded arrays indicated in the request.
     *
     * @generated from protobuf field: string app_path = 3;
     */
    appPath: string;
    /**
     * JSONPATH expression indicating where the last usage information is expanded in expanded arrays indicated in the request.
     *
     * @generated from protobuf field: string last_usage_path = 4;
     */
    lastUsagePath: string;
}
/**
 * The AppUserView contains an app user as well as paths for apps, identity users, and last usage in expanded arrays.
 *
 * @generated from protobuf message c1.api.app.v1.AppUserWithAlertCountView
 */
export interface AppUserWithAlertCountView {
    /**
     * The AppUser included in this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUser app_user = 1;
     */
    appUser?: AppUser;
    /**
     * JSONPATH expression indicating where the identity user is expanded in expanded arrays indicated in the request.
     *
     * @generated from protobuf field: string identity_user_path = 2;
     */
    identityUserPath: string;
    /**
     * JSONPATH expression indicating where the app is expanded in expanded arrays indicated in the request.
     *
     * @generated from protobuf field: string app_path = 3;
     */
    appPath: string;
    /**
     * JSONPATH expression indicating where the last usage information is expanded in expanded arrays indicated in the request.
     *
     * @generated from protobuf field: string last_usage_path = 4;
     */
    lastUsagePath: string;
    /**
     * count of active alerts
     *
     * @generated from protobuf field: int32 alert_count = 5;
     */
    alertCount: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceGetResponse
 */
export interface AppUserServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserView app_user_view = 1;
     */
    appUserView?: AppUserView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceUpdateResponse
 */
export interface AppUserServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserView app_user_view = 1;
     */
    appUserView?: AppUserView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * The satus of the applicaiton user.
 *
 * @generated from protobuf message c1.api.app.v1.AppUserStatus
 */
export interface AppUserStatus {
    /**
     * The application user status field.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUserStatus.Status status = 1;
     */
    status: AppUserStatus_Status;
    /**
     * The details of applicaiton user status.
     *
     * @generated from protobuf field: string details = 2;
     */
    details: string;
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppUserStatus.Status
 */
export enum AppUserStatus_Status {
    /**
     * Indicates that the application user account status is unknown. This should be considered invalid in a response message.
     *
     * @generated from protobuf enum value: STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Indicates that the application user account is active.
     *
     * @generated from protobuf enum value: STATUS_ENABLED = 1;
     */
    ENABLED = 1,
    /**
     * Indicates that the application user account is disabled.
     *
     * @generated from protobuf enum value: STATUS_DISABLED = 2;
     */
    DISABLED = 2,
    /**
     * Indicates that the application user account is deleted.
     *
     * @generated from protobuf enum value: STATUS_DELETED = 3;
     */
    DELETED = 3
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserRef
 */
export interface AppUserRef {
    /**
     * The ID of the application.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The ID of the app user.
     *
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserCredentialRef
 */
export interface AppUserCredentialRef {
    /**
     * The ID of the application.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The ID of the app user.
     *
     * @generated from protobuf field: string app_user_id = 2;
     */
    appUserId: string;
    /**
     * The ID of the credential.
     *
     * @generated from protobuf field: string id = 3;
     */
    id: string;
}
/**
 * Application User that represents an account in the application.
 *
 * @generated from protobuf message c1.api.app.v1.AppUser
 */
export interface AppUser {
    /**
     * The ID of the application.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * A unique idenditfier of the application user.
     *
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * The datetime, in RFC3339 format, of when the Application user was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the Application user was updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the Application user was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
    /**
     * The display name of the application user.
     *
     * @generated from protobuf field: string display_name = 6;
     */
    displayName: string;
    /**
     * The email field of the application user.
     *
     * @generated from protobuf field: string email = 7;
     */
    email: string;
    /**
     * The emails field of the application user.
     *
     * @generated from protobuf field: repeated string emails = 12;
     */
    emails: string[];
    /**
     * The username field of the application user.
     *
     * @generated from protobuf field: string username = 13;
     */
    username: string;
    /**
     * The usernames field of the application user.
     *
     * @generated from protobuf field: repeated string usernames = 14;
     */
    usernames: string[];
    /**
     * The employee IDs field of the application user.
     *
     * @generated from protobuf field: repeated string employee_ids = 16;
     */
    employeeIds: string[];
    /**
     * The profile attributes of the user in the application.
     *
     * @generated from protobuf field: google.protobuf.Struct profile = 8;
     */
    profile?: Struct;
    /**
     * The appplication user type. Type can be user, system or service.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUserType app_user_type = 9;
     */
    appUserType: AppUserType;
    /**
     * The conductor one user ID of the account owner.
     *
     * @generated from protobuf field: string identity_user_id = 10;
     */
    identityUserId: string;
    /**
     * The status of the user in the application.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUserStatus status = 11;
     */
    status?: AppUserStatus;
    /**
     * @generated from protobuf field: bool is_external = 15;
     */
    isExternal: boolean;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceCreateRequest
 */
export interface AppUserServiceCreateRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string email = 3;
     */
    email: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 4;
     */
    expandMask?: AppUserExpandMask;
}
/**
 * The AppUserServiceUpdateRequest message contains the app user and the fields to be updated.
 *
 * @generated from protobuf message c1.api.app.v1.AppUserServiceUpdateRequest
 */
export interface AppUserServiceUpdateRequest {
    /**
     * The app user with the fields to be updated.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUser app_user = 1;
     */
    appUser?: AppUser;
    /**
     * A comma sepparated list of fields to update from the app user. For example: "appUserType,identityUserId"
     * NOTE: If you specify identityUserId in the update mask, and the identityUserId field is empty in the request body, the identityUserId will be reset to the default.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
    /**
     * The expand mask defines the list of paths to be expanded in the return value.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 3;
     */
    expandMask?: AppUserExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceGetRequest
 */
export interface AppUserServiceGetRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 3;
     */
    expandMask?: AppUserExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceDeleteRequest
 */
export interface AppUserServiceDeleteRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceListRequest
 */
export interface AppUserServiceListRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 4;
     */
    expandMask?: AppUserExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceListResponse
 */
export interface AppUserServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserView list = 1;
     */
    list: AppUserView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUsersForUserServiceListRequest
 */
export interface AppUsersForUserServiceListRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string user_id = 2;
     */
    userId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 5;
     */
    expandMask?: AppUserExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUsersForUserServiceListResponse
 */
export interface AppUsersForUserServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserView list = 1;
     */
    list: AppUserView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * Search App users based on filters specified in the request body
 *
 * @generated from protobuf message c1.api.app.v1.AppUserServiceSearchRequest
 */
export interface AppUserServiceSearchRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * Query the apps with a fuzzy search on display name and description.
     *
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * A list of app user IDs to remove from the results.
     *
     * @generated from protobuf field: repeated string exclude_app_user_ids = 4;
     */
    excludeAppUserIds: string[];
    /**
     * A list of app user IDs to restrict the search to.
     *
     * @generated from protobuf field: repeated string app_user_ids = 5;
     */
    appUserIds: string[];
    /**
     * The app ID to restrict the search to.
     *
     * @generated from protobuf field: string app_id = 6;
     */
    appId: string;
    /**
     * A list of app user types to restrict the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserType app_user_types = 8;
     */
    appUserTypes: AppUserType[];
    /**
     * A list of app user statuses to restrict the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserStatus.Status app_user_statuses = 9;
     */
    appUserStatuses: AppUserStatus_Status[];
    /**
     * A list of app user status details to restrict the search to.
     *
     * @generated from protobuf field: repeated string app_user_status_details = 10;
     */
    appUserStatusDetails: string[];
    /**
     * Control the array of expanded values that are filled out in the response to this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 7;
     */
    expandMask?: AppUserExpandMask;
    /**
     * A list of user IDs to restrict the search by.
     *
     * @generated from protobuf field: repeated string user_ids = 11;
     */
    userIds: string[];
    /**
     * A list of app users to limit the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef refs = 12;
     */
    refs: AppUserRef[];
    /**
     * A list of account domains to restrict the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserDomain app_user_domains = 14;
     */
    appUserDomains: AppUserDomain[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceSearchResponse
 */
export interface AppUserServiceSearchResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserView list = 1;
     */
    list: AppUserView[];
    /**
     * List of related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retrieved.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * Search App users along with inventory alert count based on filters specified in the request body
 *
 * @generated from protobuf message c1.api.app.v1.AppUserServiceSearchWithAlertsRequest
 */
export interface AppUserServiceSearchWithAlertsRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * Query the apps with a fuzzy search on display name and description.
     *
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * A list of app user IDs to remove from the results.
     *
     * @generated from protobuf field: repeated string exclude_app_user_ids = 4;
     */
    excludeAppUserIds: string[];
    /**
     * A list of app user IDs to restrict the search to.
     *
     * @generated from protobuf field: repeated string app_user_ids = 5;
     */
    appUserIds: string[];
    /**
     * The app ID to restrict the search to.
     *
     * @generated from protobuf field: string app_id = 6;
     */
    appId: string;
    /**
     * A list of app user types to restrict the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserType app_user_types = 8;
     */
    appUserTypes: AppUserType[];
    /**
     * A list of app user statuses to restrict the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserStatus.Status app_user_statuses = 9;
     */
    appUserStatuses: AppUserStatus_Status[];
    /**
     * A list of app user status details to restrict the search to.
     *
     * @generated from protobuf field: repeated string app_user_status_details = 10;
     */
    appUserStatusDetails: string[];
    /**
     * Control the array of expanded values that are filled out in the response to this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 7;
     */
    expandMask?: AppUserExpandMask;
    /**
     * A list of user IDs to restrict the search by.
     *
     * @generated from protobuf field: repeated string user_ids = 11;
     */
    userIds: string[];
    /**
     * A list of app users to limit the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef refs = 12;
     */
    refs: AppUserRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserDomain app_user_domains = 13;
     */
    appUserDomains: AppUserDomain[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceSearchWithAlertsResponse
 */
export interface AppUserServiceSearchWithAlertsResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserWithAlertCountView list = 1;
     */
    list: AppUserWithAlertCountView[];
    /**
     * List of related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retrieved.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceSearchCountsByTypeRequest
 */
export interface AppUserServiceSearchCountsByTypeRequest {
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceSearchCountRequest
 */
export interface AppUserServiceSearchCountRequest {
    /**
     * @generated from protobuf field: string query = 1;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string exclude_app_user_ids = 2;
     */
    excludeAppUserIds: string[];
    /**
     * @generated from protobuf field: repeated string app_user_ids = 3;
     */
    appUserIds: string[];
    /**
     * @generated from protobuf field: string app_id = 4;
     */
    appId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserType app_user_types = 5;
     */
    appUserTypes: AppUserType[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserStatus.Status app_user_statuses = 6;
     */
    appUserStatuses: AppUserStatus_Status[];
    /**
     * @generated from protobuf field: repeated string app_user_status_details = 7;
     */
    appUserStatusDetails: string[];
    /**
     * @generated from protobuf field: repeated string user_ids = 8;
     */
    userIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef refs = 9;
     */
    refs: AppUserRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserDomain app_user_domains = 11;
     */
    appUserDomains: AppUserDomain[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceSearchCountResponse
 */
export interface AppUserServiceSearchCountResponse {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceSearchCountsByTypeResponse
 */
export interface AppUserServiceSearchCountsByTypeResponse {
    /**
     * @generated from protobuf field: int64 user = 1;
     */
    user: number;
    /**
     * @generated from protobuf field: int64 service_account = 2;
     */
    serviceAccount: number;
    /**
     * @generated from protobuf field: int64 system_account = 3;
     */
    systemAccount: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetUserSearchTermsRequest
 */
export interface GetUserSearchTermsRequest {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserServiceSearchRequest search = 1;
     */
    search?: AppUserServiceSearchRequest;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserSearchTerm term = 2;
     */
    term: AppUserSearchTerm;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_count = 4;
     */
    includeCount: boolean;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetUserSearchTermsResponse
 */
export interface GetUserSearchTermsResponse {
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 1;
     */
    facets?: Facets;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppWithUserCountRollup
 */
export interface AppWithUserCountRollup {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1;
     */
    app?: App;
    /**
     * @generated from protobuf field: int64 user_count = 2;
     */
    userCount: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppWithUserCountRollupRequest
 */
export interface AppWithUserCountRollupRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppWithUserCountRollupResponse
 */
export interface AppWithUserCountRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppWithUserCountRollup list = 1;
     */
    list: AppWithUserCountRollup[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CountAppUsersWithoutResponsiblePartyRequest
 */
export interface CountAppUsersWithoutResponsiblePartyRequest {
}
/**
 * @generated from protobuf message c1.api.app.v1.CountAppUsersWithoutResponsiblePartyResponse
 */
export interface CountAppUsersWithoutResponsiblePartyResponse {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUsersWithoutResponsiblePartyRequest
 */
export interface AppUsersWithoutResponsiblePartyRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 4;
     */
    expandMask?: AppUserExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.TotalCountOrphanedAccountsRequest
 */
export interface TotalCountOrphanedAccountsRequest {
}
/**
 * @generated from protobuf message c1.api.app.v1.TotalCountOrphanedAccountsResponse
 */
export interface TotalCountOrphanedAccountsResponse {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * EncryptedData is a message that contains encrypted bytes and metadata.
 *
 * @generated from protobuf message c1.api.app.v1.EncryptedData
 */
export interface EncryptedData {
    /**
     * The encryption provider used to encrypt the data.
     *
     * @generated from protobuf field: string provider = 1;
     */
    provider: string;
    /**
     * The key ID used to encrypt the data.
     *
     * @generated from protobuf field: string key_id = 2;
     */
    keyId: string;
    /**
     * The human-readable name of the encrypted data.
     *
     * @generated from protobuf field: string name = 3;
     */
    name: string;
    /**
     * The human-readable description of the encrypted data.
     *
     * @generated from protobuf field: string description = 4;
     */
    description: string;
    /**
     * The (optional) JSON schema of the encrypted data.
     *
     * @generated from protobuf field: string schema = 5;
     */
    schema: string;
    /**
     * The encrypted bytes.
     *
     * @generated from protobuf field: bytes encrypted_bytes = 6;
     */
    encryptedBytes: Uint8Array;
}
/**
 * A credentials for the Application User that represents an account in the application.
 *
 * @generated from protobuf message c1.api.app.v1.AppUserCredential
 */
export interface AppUserCredential {
    /**
     * The ID of the application.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * A unique identifier of the application user.
     *
     * @generated from protobuf field: string app_user_id = 2;
     */
    appUserId: string;
    /**
     * A unique identifier of the credential.
     *
     * @generated from protobuf field: string id = 3;
     */
    id: string;
    /**
     * The datetime, in RFC3339 format, of when the credential was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the credential was updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the credential was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6;
     */
    deletedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the credential will expire.
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 7;
     */
    expiresAt?: Timestamp;
    /**
     * @generated from protobuf oneof: credential
     */
    credential: {
        oneofKind: "encryptedData";
        /**
         * The encrypted data of the credential.
         *
         * @generated from protobuf field: c1.api.app.v1.EncryptedData encrypted_data = 100;
         */
        encryptedData: EncryptedData;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserCredentialView
 */
export interface AppUserCredentialView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserCredential app_user_credential = 1;
     */
    appUserCredential?: AppUserCredential;
    /**
     * @generated from protobuf field: string app_path = 2;
     */
    appPath: string;
    /**
     * @generated from protobuf field: string app_user_path = 3;
     */
    appUserPath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserCredentialViewWithVaultID
 */
export interface AppUserCredentialViewWithVaultID {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserCredentialView item = 1;
     */
    item?: AppUserCredentialView;
    /**
     * @generated from protobuf field: string vault_id = 2;
     */
    vaultId: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserCredentialExpandMask
 */
export interface AppUserCredentialExpandMask {
    /**
     * The paths to expand in the response. May be any combination of "*", "app_id", and "app_user_id".
     *
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceListCredentialsRequest
 */
export interface AppUserServiceListCredentialsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 2;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceListCredentialsResponse
 */
export interface AppUserServiceListCredentialsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserCredential list = 1;
     */
    list: AppUserCredential[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserSearchFilter
 */
export interface AppUserSearchFilter {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef refs = 1;
     */
    refs: AppUserRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserCredentialServiceSearchTermsRequest
 */
export interface AppUserCredentialServiceSearchTermsRequest {
    /**
     * @generated from protobuf field: c1.api.app.v1.SearchAppUserCredentialsByVaultIDRequest search = 1;
     */
    search?: SearchAppUserCredentialsByVaultIDRequest;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserCredentialServiceSearchTermsRequest.TermType term = 2;
     */
    term: AppUserCredentialServiceSearchTermsRequest_TermType;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_count = 4;
     */
    includeCount: boolean;
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppUserCredentialServiceSearchTermsRequest.TermType
 */
export enum AppUserCredentialServiceSearchTermsRequest_TermType {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APPS = 1;
     */
    APPS = 1
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserCredentialServiceSearchTermsResponse
 */
export interface AppUserCredentialServiceSearchTermsResponse {
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 1;
     */
    facets?: Facets;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppUserCredentialsWithVaultRequest
 */
export interface ListAppUserCredentialsWithVaultRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 2;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserCredentialExpandMask expand_mask = 5;
     */
    expandMask?: AppUserCredentialExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppUserCredentialsWithVaultResponse
 */
export interface ListAppUserCredentialsWithVaultResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserCredentialViewWithVaultID list = 1;
     */
    list: AppUserCredentialViewWithVaultID[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppUserCredentialsByVaultIDRequest
 */
export interface SearchAppUserCredentialsByVaultIDRequest {
    /**
     * @generated from protobuf field: string vault_id = 1;
     */
    vaultId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserCredentialExpandMask expand_mask = 4;
     */
    expandMask?: AppUserCredentialExpandMask;
    /**
     * Fuzzy search
     *
     * @generated from protobuf field: string query = 5;
     */
    query: string;
    /**
     * A list of app IDs to restrict the search by.
     *
     * @generated from protobuf field: repeated string app_ids = 6;
     */
    appIds: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppUserCredentialsByVaultIDResponse
 */
export interface SearchAppUserCredentialsByVaultIDResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserCredentialView list = 1;
     */
    list: AppUserCredentialView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppUserHasAppUserCredentialsRequest
 */
export interface SearchAppUserHasAppUserCredentialsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 2;
     */
    appUserId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppUserHasAppUserCredentialsResponse
 */
export interface SearchAppUserHasAppUserCredentialsResponse {
    /**
     * @generated from protobuf field: bool has_app_user_credentials = 1;
     */
    hasAppUserCredentials: boolean;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserCredentialServiceDeleteRequest
 */
export interface AppUserCredentialServiceDeleteRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 2;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string credential_id = 3;
     */
    credentialId: string;
}
/**
 * Empty response body. Status code indicates success.
 *
 * @generated from protobuf message c1.api.app.v1.AppUserCredentialServiceDeleteResponse
 */
export interface AppUserCredentialServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.AppAccountRollup
 */
export interface AppAccountRollup {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: int64 count = 2;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.CountAppUsersByAppsRequest
 */
export interface CountAppUsersByAppsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppRef app_refs = 1;
     */
    appRefs: AppRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.CountAppUsersByAppsResponse
 */
export interface CountAppUsersByAppsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppAccountRollup list = 1;
     */
    list: AppAccountRollup[];
}
/**
 * Different application user types.
 * Copied in c1.api.task.v1.Search, c1.api.accessreview.v1.accessreview
 * There's an issue with protogen when referencing enums from other packages.
 *
 * @generated from protobuf enum c1.api.app.v1.AppUserType
 */
export enum AppUserType {
    /**
     * User type is not specified. This should be considered an invalid state in a response.
     *
     * @generated from protobuf enum value: APP_USER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Identifies the user as a person.
     *
     * @generated from protobuf enum value: APP_USER_TYPE_USER = 1;
     */
    USER = 1,
    /**
     * Identifies the user as a service.
     *
     * @generated from protobuf enum value: APP_USER_TYPE_SERVICE_ACCOUNT = 2;
     */
    SERVICE_ACCOUNT = 2,
    /**
     * Identifies the user as a system.
     *
     * @generated from protobuf enum value: APP_USER_TYPE_SYSTEM_ACCOUNT = 3;
     */
    SYSTEM_ACCOUNT = 3
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppUserDomain
 */
export enum AppUserDomain {
    /**
     * @generated from protobuf enum value: APP_USER_DOMAIN_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_USER_DOMAIN_EXTERNAL = 1;
     */
    EXTERNAL = 1,
    /**
     * @generated from protobuf enum value: APP_USER_DOMAIN_TRUSTED = 2;
     */
    TRUSTED = 2
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppUserSearchTerm
 */
export enum AppUserSearchTerm {
    /**
     * @generated from protobuf enum value: APP_USER_STATUS = 0;
     */
    APP_USER_STATUS = 0,
    /**
     * @generated from protobuf enum value: APP_USER_TYPE = 1;
     */
    APP_USER_TYPE = 1,
    /**
     * @generated from protobuf enum value: APP_USER_STATUS_DETAILS = 2;
     */
    APP_USER_STATUS_DETAILS = 2,
    /**
     * @generated from protobuf enum value: IDENTITY_USER_IDS = 3;
     */
    IDENTITY_USER_IDS = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class SearchOrphanedAccountsRequest$Type extends MessageType<SearchOrphanedAccountsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchOrphanedAccountsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchOrphanedAccountsRequest
 */
export const SearchOrphanedAccountsRequest = new SearchOrphanedAccountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchOrphanedAccountsResponse$Type extends MessageType<SearchOrphanedAccountsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchOrphanedAccountsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchOrphanedAccountsResponse
 */
export const SearchOrphanedAccountsResponse = new SearchOrphanedAccountsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAndCount$Type extends MessageType<UserAndCount> {
    constructor() {
        super("c1.api.app.v1.UserAndCount", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUser },
            { no: 2, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UserAndCount
 */
export const UserAndCount = new UserAndCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HighRiskUsersAndGrantsRequest$Type extends MessageType<HighRiskUsersAndGrantsRequest> {
    constructor() {
        super("c1.api.app.v1.HighRiskUsersAndGrantsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.HighRiskUsersAndGrantsRequest
 */
export const HighRiskUsersAndGrantsRequest = new HighRiskUsersAndGrantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HighRiskUsersAndGrantsResponse$Type extends MessageType<HighRiskUsersAndGrantsResponse> {
    constructor() {
        super("c1.api.app.v1.HighRiskUsersAndGrantsResponse", [
            { no: 1, name: "counts", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserView },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 4, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.HighRiskUsersAndGrantsResponse
 */
export const HighRiskUsersAndGrantsResponse = new HighRiskUsersAndGrantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountHighRiskUsersAndGrantsRequest$Type extends MessageType<CountHighRiskUsersAndGrantsRequest> {
    constructor() {
        super("c1.api.app.v1.CountHighRiskUsersAndGrantsRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountHighRiskUsersAndGrantsRequest
 */
export const CountHighRiskUsersAndGrantsRequest = new CountHighRiskUsersAndGrantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountHighRiskUsersAndGrantsResponse$Type extends MessageType<CountHighRiskUsersAndGrantsResponse> {
    constructor() {
        super("c1.api.app.v1.CountHighRiskUsersAndGrantsResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountHighRiskUsersAndGrantsResponse
 */
export const CountHighRiskUsersAndGrantsResponse = new CountHighRiskUsersAndGrantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserResponsiblePartyExpandMask$Type extends MessageType<AppUserResponsiblePartyExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppUserResponsiblePartyExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "user_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserResponsiblePartyExpandMask
 */
export const AppUserResponsiblePartyExpandMask = new AppUserResponsiblePartyExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserResponsiblePartyServiceGetRequest$Type extends MessageType<AppUserResponsiblePartyServiceGetRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserResponsiblePartyServiceGetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppUserResponsiblePartyExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserResponsiblePartyServiceGetRequest
 */
export const AppUserResponsiblePartyServiceGetRequest = new AppUserResponsiblePartyServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserResponsiblePartyServiceSetRequest$Type extends MessageType<AppUserResponsiblePartyServiceSetRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserResponsiblePartyServiceSetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppUserResponsiblePartyExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserResponsiblePartyServiceSetRequest
 */
export const AppUserResponsiblePartyServiceSetRequest = new AppUserResponsiblePartyServiceSetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserResponsiblePartyServiceResetRequest$Type extends MessageType<AppUserResponsiblePartyServiceResetRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserResponsiblePartyServiceResetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppUserResponsiblePartyExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserResponsiblePartyServiceResetRequest
 */
export const AppUserResponsiblePartyServiceResetRequest = new AppUserResponsiblePartyServiceResetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserExpandMask$Type extends MessageType<AppUserExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppUserExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "identity_user_id", "app_id", "last_usage"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserExpandMask
 */
export const AppUserExpandMask = new AppUserExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserView$Type extends MessageType<AppUserView> {
    constructor() {
        super("c1.api.app.v1.AppUserView", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUser },
            { no: 2, name: "identity_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "last_usage_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserView
 */
export const AppUserView = new AppUserView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserWithAlertCountView$Type extends MessageType<AppUserWithAlertCountView> {
    constructor() {
        super("c1.api.app.v1.AppUserWithAlertCountView", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUser },
            { no: 2, name: "identity_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "last_usage_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "alert_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserWithAlertCountView
 */
export const AppUserWithAlertCountView = new AppUserWithAlertCountView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceGetResponse$Type extends MessageType<AppUserServiceGetResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceGetResponse", [
            { no: 1, name: "app_user_view", kind: "message", T: () => AppUserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceGetResponse
 */
export const AppUserServiceGetResponse = new AppUserServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceUpdateResponse$Type extends MessageType<AppUserServiceUpdateResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceUpdateResponse", [
            { no: 1, name: "app_user_view", kind: "message", T: () => AppUserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceUpdateResponse
 */
export const AppUserServiceUpdateResponse = new AppUserServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserStatus$Type extends MessageType<AppUserStatus> {
    constructor() {
        super("c1.api.app.v1.AppUserStatus", [
            { no: 1, name: "status", kind: "enum", T: () => ["c1.api.app.v1.AppUserStatus.Status", AppUserStatus_Status, "STATUS_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "details", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserStatus
 */
export const AppUserStatus = new AppUserStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserRef$Type extends MessageType<AppUserRef> {
    constructor() {
        super("c1.api.app.v1.AppUserRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserRef
 */
export const AppUserRef = new AppUserRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCredentialRef$Type extends MessageType<AppUserCredentialRef> {
    constructor() {
        super("c1.api.app.v1.AppUserCredentialRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserCredentialRef
 */
export const AppUserCredentialRef = new AppUserCredentialRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUser$Type extends MessageType<AppUser> {
    constructor() {
        super("c1.api.app.v1.AppUser", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 12, name: "emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { items: { string: { minBytes: "0", maxBytes: "4096" } } } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 13, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 14, name: "usernames", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { items: { string: { minBytes: "0", maxBytes: "4096" } } } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 16, name: "employee_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { items: { string: { minBytes: "0", maxBytes: "4096" } } } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "profile", kind: "message", T: () => Struct, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "app_user_type", kind: "enum", T: () => ["c1.api.app.v1.AppUserType", AppUserType, "APP_USER_TYPE_"] },
            { no: 10, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "status", kind: "message", T: () => AppUserStatus, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 15, name: "is_external", kind: "scalar", T: 8 /*ScalarType.BOOL*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUser
 */
export const AppUser = new AppUser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceCreateRequest$Type extends MessageType<AppUserServiceCreateRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceCreateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "512" } } } },
            { no: 3, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceCreateRequest
 */
export const AppUserServiceCreateRequest = new AppUserServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceUpdateRequest$Type extends MessageType<AppUserServiceUpdateRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceUpdateRequest", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUser, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceUpdateRequest
 */
export const AppUserServiceUpdateRequest = new AppUserServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceGetRequest$Type extends MessageType<AppUserServiceGetRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceGetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceGetRequest
 */
export const AppUserServiceGetRequest = new AppUserServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceDeleteRequest$Type extends MessageType<AppUserServiceDeleteRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceDeleteRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceDeleteRequest
 */
export const AppUserServiceDeleteRequest = new AppUserServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceListRequest$Type extends MessageType<AppUserServiceListRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceListRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceListRequest
 */
export const AppUserServiceListRequest = new AppUserServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceListResponse$Type extends MessageType<AppUserServiceListResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceListResponse
 */
export const AppUserServiceListResponse = new AppUserServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUsersForUserServiceListRequest$Type extends MessageType<AppUsersForUserServiceListRequest> {
    constructor() {
        super("c1.api.app.v1.AppUsersForUserServiceListRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUsersForUserServiceListRequest
 */
export const AppUsersForUserServiceListRequest = new AppUsersForUserServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUsersForUserServiceListResponse$Type extends MessageType<AppUsersForUserServiceListResponse> {
    constructor() {
        super("c1.api.app.v1.AppUsersForUserServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUsersForUserServiceListResponse
 */
export const AppUsersForUserServiceListResponse = new AppUsersForUserServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceSearchRequest$Type extends MessageType<AppUserServiceSearchRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "exclude_app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$|" } } } },
            { no: 8, name: "app_user_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserType", AppUserType, "APP_USER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 9, name: "app_user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserStatus.Status", AppUserStatus_Status, "STATUS_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 10, name: "app_user_status_details", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "1", maxBytes: "1024" } } } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => AppUserExpandMask },
            { no: 11, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^([a-zA-Z0-9]{27}|none)$" } } } } } },
            { no: 12, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef },
            { no: 14, name: "app_user_domains", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserDomain", AppUserDomain, "APP_USER_DOMAIN_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceSearchRequest
 */
export const AppUserServiceSearchRequest = new AppUserServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceSearchResponse$Type extends MessageType<AppUserServiceSearchResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceSearchResponse
 */
export const AppUserServiceSearchResponse = new AppUserServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceSearchWithAlertsRequest$Type extends MessageType<AppUserServiceSearchWithAlertsRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceSearchWithAlertsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "exclude_app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$|" } } } },
            { no: 8, name: "app_user_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserType", AppUserType, "APP_USER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 9, name: "app_user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserStatus.Status", AppUserStatus_Status, "STATUS_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 10, name: "app_user_status_details", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "1", maxBytes: "1024" } } } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => AppUserExpandMask },
            { no: 11, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^([a-zA-Z0-9]{27}|none)$" } } } } } },
            { no: 12, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef },
            { no: 13, name: "app_user_domains", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserDomain", AppUserDomain, "APP_USER_DOMAIN_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceSearchWithAlertsRequest
 */
export const AppUserServiceSearchWithAlertsRequest = new AppUserServiceSearchWithAlertsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceSearchWithAlertsResponse$Type extends MessageType<AppUserServiceSearchWithAlertsResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceSearchWithAlertsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserWithAlertCountView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceSearchWithAlertsResponse
 */
export const AppUserServiceSearchWithAlertsResponse = new AppUserServiceSearchWithAlertsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceSearchCountsByTypeRequest$Type extends MessageType<AppUserServiceSearchCountsByTypeRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceSearchCountsByTypeRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceSearchCountsByTypeRequest
 */
export const AppUserServiceSearchCountsByTypeRequest = new AppUserServiceSearchCountsByTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceSearchCountRequest$Type extends MessageType<AppUserServiceSearchCountRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceSearchCountRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "exclude_app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$|" } } } },
            { no: 5, name: "app_user_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserType", AppUserType, "APP_USER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 6, name: "app_user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserStatus.Status", AppUserStatus_Status, "STATUS_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 7, name: "app_user_status_details", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "1", maxBytes: "1024" } } } } } },
            { no: 8, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 9, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef },
            { no: 11, name: "app_user_domains", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserDomain", AppUserDomain, "APP_USER_DOMAIN_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceSearchCountRequest
 */
export const AppUserServiceSearchCountRequest = new AppUserServiceSearchCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceSearchCountResponse$Type extends MessageType<AppUserServiceSearchCountResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceSearchCountResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceSearchCountResponse
 */
export const AppUserServiceSearchCountResponse = new AppUserServiceSearchCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceSearchCountsByTypeResponse$Type extends MessageType<AppUserServiceSearchCountsByTypeResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceSearchCountsByTypeResponse", [
            { no: 1, name: "user", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "service_account", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "system_account", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceSearchCountsByTypeResponse
 */
export const AppUserServiceSearchCountsByTypeResponse = new AppUserServiceSearchCountsByTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserSearchTermsRequest$Type extends MessageType<GetUserSearchTermsRequest> {
    constructor() {
        super("c1.api.app.v1.GetUserSearchTermsRequest", [
            { no: 1, name: "search", kind: "message", T: () => AppUserServiceSearchRequest },
            { no: 2, name: "term", kind: "enum", T: () => ["c1.api.app.v1.AppUserSearchTerm", AppUserSearchTerm], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_count", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetUserSearchTermsRequest
 */
export const GetUserSearchTermsRequest = new GetUserSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserSearchTermsResponse$Type extends MessageType<GetUserSearchTermsResponse> {
    constructor() {
        super("c1.api.app.v1.GetUserSearchTermsResponse", [
            { no: 1, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetUserSearchTermsResponse
 */
export const GetUserSearchTermsResponse = new GetUserSearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppWithUserCountRollup$Type extends MessageType<AppWithUserCountRollup> {
    constructor() {
        super("c1.api.app.v1.AppWithUserCountRollup", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "user_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppWithUserCountRollup
 */
export const AppWithUserCountRollup = new AppWithUserCountRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppWithUserCountRollupRequest$Type extends MessageType<AppWithUserCountRollupRequest> {
    constructor() {
        super("c1.api.app.v1.AppWithUserCountRollupRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$|" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppWithUserCountRollupRequest
 */
export const AppWithUserCountRollupRequest = new AppWithUserCountRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppWithUserCountRollupResponse$Type extends MessageType<AppWithUserCountRollupResponse> {
    constructor() {
        super("c1.api.app.v1.AppWithUserCountRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppWithUserCountRollup },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppWithUserCountRollupResponse
 */
export const AppWithUserCountRollupResponse = new AppWithUserCountRollupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountAppUsersWithoutResponsiblePartyRequest$Type extends MessageType<CountAppUsersWithoutResponsiblePartyRequest> {
    constructor() {
        super("c1.api.app.v1.CountAppUsersWithoutResponsiblePartyRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountAppUsersWithoutResponsiblePartyRequest
 */
export const CountAppUsersWithoutResponsiblePartyRequest = new CountAppUsersWithoutResponsiblePartyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountAppUsersWithoutResponsiblePartyResponse$Type extends MessageType<CountAppUsersWithoutResponsiblePartyResponse> {
    constructor() {
        super("c1.api.app.v1.CountAppUsersWithoutResponsiblePartyResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountAppUsersWithoutResponsiblePartyResponse
 */
export const CountAppUsersWithoutResponsiblePartyResponse = new CountAppUsersWithoutResponsiblePartyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUsersWithoutResponsiblePartyRequest$Type extends MessageType<AppUsersWithoutResponsiblePartyRequest> {
    constructor() {
        super("c1.api.app.v1.AppUsersWithoutResponsiblePartyRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$|" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUsersWithoutResponsiblePartyRequest
 */
export const AppUsersWithoutResponsiblePartyRequest = new AppUsersWithoutResponsiblePartyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TotalCountOrphanedAccountsRequest$Type extends MessageType<TotalCountOrphanedAccountsRequest> {
    constructor() {
        super("c1.api.app.v1.TotalCountOrphanedAccountsRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.TotalCountOrphanedAccountsRequest
 */
export const TotalCountOrphanedAccountsRequest = new TotalCountOrphanedAccountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TotalCountOrphanedAccountsResponse$Type extends MessageType<TotalCountOrphanedAccountsResponse> {
    constructor() {
        super("c1.api.app.v1.TotalCountOrphanedAccountsResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.TotalCountOrphanedAccountsResponse
 */
export const TotalCountOrphanedAccountsResponse = new TotalCountOrphanedAccountsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EncryptedData$Type extends MessageType<EncryptedData> {
    constructor() {
        super("c1.api.app.v1.EncryptedData", [
            { no: 1, name: "provider", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "key_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "schema", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "encrypted_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.EncryptedData
 */
export const EncryptedData = new EncryptedData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCredential$Type extends MessageType<AppUserCredential> {
    constructor() {
        super("c1.api.app.v1.AppUserCredential", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 100, name: "encrypted_data", kind: "message", oneof: "credential", T: () => EncryptedData }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserCredential
 */
export const AppUserCredential = new AppUserCredential$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCredentialView$Type extends MessageType<AppUserCredentialView> {
    constructor() {
        super("c1.api.app.v1.AppUserCredentialView", [
            { no: 1, name: "app_user_credential", kind: "message", T: () => AppUserCredential },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserCredentialView
 */
export const AppUserCredentialView = new AppUserCredentialView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCredentialViewWithVaultID$Type extends MessageType<AppUserCredentialViewWithVaultID> {
    constructor() {
        super("c1.api.app.v1.AppUserCredentialViewWithVaultID", [
            { no: 1, name: "item", kind: "message", T: () => AppUserCredentialView },
            { no: 2, name: "vault_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserCredentialViewWithVaultID
 */
export const AppUserCredentialViewWithVaultID = new AppUserCredentialViewWithVaultID$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCredentialExpandMask$Type extends MessageType<AppUserCredentialExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppUserCredentialExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "app_user_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserCredentialExpandMask
 */
export const AppUserCredentialExpandMask = new AppUserCredentialExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceListCredentialsRequest$Type extends MessageType<AppUserServiceListCredentialsRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceListCredentialsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceListCredentialsRequest
 */
export const AppUserServiceListCredentialsRequest = new AppUserServiceListCredentialsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceListCredentialsResponse$Type extends MessageType<AppUserServiceListCredentialsResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceListCredentialsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserCredential },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceListCredentialsResponse
 */
export const AppUserServiceListCredentialsResponse = new AppUserServiceListCredentialsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserSearchFilter$Type extends MessageType<AppUserSearchFilter> {
    constructor() {
        super("c1.api.app.v1.AppUserSearchFilter", [
            { no: 1, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserSearchFilter
 */
export const AppUserSearchFilter = new AppUserSearchFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCredentialServiceSearchTermsRequest$Type extends MessageType<AppUserCredentialServiceSearchTermsRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserCredentialServiceSearchTermsRequest", [
            { no: 1, name: "search", kind: "message", T: () => SearchAppUserCredentialsByVaultIDRequest },
            { no: 2, name: "term", kind: "enum", T: () => ["c1.api.app.v1.AppUserCredentialServiceSearchTermsRequest.TermType", AppUserCredentialServiceSearchTermsRequest_TermType] },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "include_count", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserCredentialServiceSearchTermsRequest
 */
export const AppUserCredentialServiceSearchTermsRequest = new AppUserCredentialServiceSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCredentialServiceSearchTermsResponse$Type extends MessageType<AppUserCredentialServiceSearchTermsResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserCredentialServiceSearchTermsResponse", [
            { no: 1, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserCredentialServiceSearchTermsResponse
 */
export const AppUserCredentialServiceSearchTermsResponse = new AppUserCredentialServiceSearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppUserCredentialsWithVaultRequest$Type extends MessageType<ListAppUserCredentialsWithVaultRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppUserCredentialsWithVaultRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppUserCredentialExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppUserCredentialsWithVaultRequest
 */
export const ListAppUserCredentialsWithVaultRequest = new ListAppUserCredentialsWithVaultRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppUserCredentialsWithVaultResponse$Type extends MessageType<ListAppUserCredentialsWithVaultResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppUserCredentialsWithVaultResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserCredentialViewWithVaultID },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppUserCredentialsWithVaultResponse
 */
export const ListAppUserCredentialsWithVaultResponse = new ListAppUserCredentialsWithVaultResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppUserCredentialsByVaultIDRequest$Type extends MessageType<SearchAppUserCredentialsByVaultIDRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppUserCredentialsByVaultIDRequest", [
            { no: 1, name: "vault_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppUserCredentialExpandMask },
            { no: 5, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppUserCredentialsByVaultIDRequest
 */
export const SearchAppUserCredentialsByVaultIDRequest = new SearchAppUserCredentialsByVaultIDRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppUserCredentialsByVaultIDResponse$Type extends MessageType<SearchAppUserCredentialsByVaultIDResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppUserCredentialsByVaultIDResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserCredentialView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppUserCredentialsByVaultIDResponse
 */
export const SearchAppUserCredentialsByVaultIDResponse = new SearchAppUserCredentialsByVaultIDResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppUserHasAppUserCredentialsRequest$Type extends MessageType<SearchAppUserHasAppUserCredentialsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppUserHasAppUserCredentialsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppUserHasAppUserCredentialsRequest
 */
export const SearchAppUserHasAppUserCredentialsRequest = new SearchAppUserHasAppUserCredentialsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppUserHasAppUserCredentialsResponse$Type extends MessageType<SearchAppUserHasAppUserCredentialsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppUserHasAppUserCredentialsResponse", [
            { no: 1, name: "has_app_user_credentials", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppUserHasAppUserCredentialsResponse
 */
export const SearchAppUserHasAppUserCredentialsResponse = new SearchAppUserHasAppUserCredentialsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCredentialServiceDeleteRequest$Type extends MessageType<AppUserCredentialServiceDeleteRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserCredentialServiceDeleteRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "credential_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserCredentialServiceDeleteRequest
 */
export const AppUserCredentialServiceDeleteRequest = new AppUserCredentialServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCredentialServiceDeleteResponse$Type extends MessageType<AppUserCredentialServiceDeleteResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserCredentialServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserCredentialServiceDeleteResponse
 */
export const AppUserCredentialServiceDeleteResponse = new AppUserCredentialServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppAccountRollup$Type extends MessageType<AppAccountRollup> {
    constructor() {
        super("c1.api.app.v1.AppAccountRollup", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppAccountRollup
 */
export const AppAccountRollup = new AppAccountRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountAppUsersByAppsRequest$Type extends MessageType<CountAppUsersByAppsRequest> {
    constructor() {
        super("c1.api.app.v1.CountAppUsersByAppsRequest", [
            { no: 1, name: "app_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "100", items: { message: { skip: false } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountAppUsersByAppsRequest
 */
export const CountAppUsersByAppsRequest = new CountAppUsersByAppsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountAppUsersByAppsResponse$Type extends MessageType<CountAppUsersByAppsResponse> {
    constructor() {
        super("c1.api.app.v1.CountAppUsersByAppsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppAccountRollup }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountAppUsersByAppsResponse
 */
export const CountAppUsersByAppsResponse = new CountAppUsersByAppsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppUserService
 */
export const AppUserService = new ServiceType("c1.api.app.v1.AppUserService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: AppUserServiceGetRequest, O: AppUserServiceGetResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/app_users", query: { page_size: "page_size", page_token: "page_token" }, group: "AppUsers" }] } }, I: AppUserServiceListRequest, O: AppUserServiceListResponse },
    { name: "ListAppUsersForUser", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/users/{user_id}/app_users", query: { page_size: "page_size", page_token: "page_token" }, group: "AppUsers" }] } }, I: AppUsersForUserServiceListRequest, O: AppUsersForUserServiceListResponse },
    { name: "ListAppUserCredentials", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/app_users/{app_user_id}/credentials", query: { page_size: "page_size", page_token: "page_token" }, group: "AppUsers" }] } }, I: AppUserServiceListCredentialsRequest, O: AppUserServiceListCredentialsResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: AppUserServiceCreateRequest, O: AppUserServiceGetResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_user.app_id}/app_users/{app_user.id}", group: "AppUsers" }] } }, I: AppUserServiceUpdateRequest, O: AppUserServiceUpdateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: AppUserServiceDeleteRequest, O: Empty },
    { name: "Search", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/app_users", group: "AppUsers" }] } }, I: AppUserServiceSearchRequest, O: AppUserServiceSearchResponse },
    { name: "SearchWithAlerts", options: { "authz.method": { role: "VIEWER" } }, I: AppUserServiceSearchWithAlertsRequest, O: AppUserServiceSearchWithAlertsResponse },
    { name: "SearchCount", options: { "authz.method": { role: "VIEWER" } }, I: AppUserServiceSearchCountRequest, O: AppUserServiceSearchCountResponse },
    { name: "SearchCountsByType", options: { "authz.method": { role: "VIEWER" } }, I: AppUserServiceSearchCountsByTypeRequest, O: AppUserServiceSearchCountsByTypeResponse },
    { name: "GetUserSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: GetUserSearchTermsRequest, O: GetUserSearchTermsResponse },
    { name: "CountOrphanedAccounts", options: { "authz.method": { role: "VIEWER" } }, I: AppWithUserCountRollupRequest, O: AppWithUserCountRollupResponse },
    { name: "CountAppUsersWithoutResponsibleParty", options: { "authz.method": { role: "VIEWER" } }, I: CountAppUsersWithoutResponsiblePartyRequest, O: CountAppUsersWithoutResponsiblePartyResponse },
    { name: "AppUsersWithoutResponsibleParty", options: { "authz.method": { role: "VIEWER" } }, I: AppUsersWithoutResponsiblePartyRequest, O: AppUserServiceListResponse },
    { name: "HighRiskUsersAndGrants", options: { "authz.method": { role: "VIEWER" } }, I: HighRiskUsersAndGrantsRequest, O: HighRiskUsersAndGrantsResponse },
    { name: "CountHighRiskUsersAndGrants", options: { "authz.method": { role: "VIEWER" } }, I: CountHighRiskUsersAndGrantsRequest, O: CountHighRiskUsersAndGrantsResponse },
    { name: "TotalCountOrphanedAccounts", options: { "authz.method": { role: "VIEWER" } }, I: TotalCountOrphanedAccountsRequest, O: TotalCountOrphanedAccountsResponse },
    { name: "SearchOrphanedAccounts", options: { "authz.method": { role: "VIEWER" } }, I: SearchOrphanedAccountsRequest, O: SearchOrphanedAccountsResponse },
    { name: "CountAppUsersByApps", options: { "authz.method": { role: "VIEWER" } }, I: CountAppUsersByAppsRequest, O: CountAppUsersByAppsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppUserCredentialService
 */
export const AppUserCredentialService = new ServiceType("c1.api.app.v1.AppUserCredentialService", [
    { name: "ListAppUserCredentialsWithVault", options: { "authz.method": { role: "VIEWER" } }, I: ListAppUserCredentialsWithVaultRequest, O: ListAppUserCredentialsWithVaultResponse },
    { name: "GetSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: AppUserCredentialServiceSearchTermsRequest, O: AppUserCredentialServiceSearchTermsResponse },
    { name: "SearchAppUserCredentialsByVaultID", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppUserCredentialsByVaultIDRequest, O: SearchAppUserCredentialsByVaultIDResponse },
    { name: "SearchAppUserHasAppUserCredentials", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppUserHasAppUserCredentialsRequest, O: SearchAppUserHasAppUserCredentialsResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: AppUserCredentialServiceDeleteRequest, O: AppUserCredentialServiceDeleteResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppUserResponsiblePartyService
 */
export const AppUserResponsiblePartyService = new ServiceType("c1.api.app.v1.AppUserResponsiblePartyService", [
    { name: "SetIdentity", options: { "authz.method": { role: "EDITOR" } }, I: AppUserResponsiblePartyServiceSetRequest, O: AppUserServiceGetResponse },
    { name: "ResetIdentity", options: { "authz.method": { role: "EDITOR" } }, I: AppUserResponsiblePartyServiceResetRequest, O: AppUserServiceGetResponse }
]);
